import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  id: "citesModal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTitleComponent = _resolveComponent("ModalTitleComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalTitleComponent, { title: "CITES" }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("p", null, " Some of the woods I use — such as grenadilla (African blackwood) — are protected under CITES, the Convention on International Trade in Endangered Species of Wild Fauna and Flora. I source all such wood legally and can document its origin. "),
          _createElementVNode("p", null, " However, I do not ship instruments made from CITES-protected wood to countries outside the EU: doing so would require export permits that are not practical for individual, hand-made instruments. If you are based outside the EU, we can simply choose a non-CITES wood for your instrument — just get in touch. ")
        ], -1))
      ])
    ])
  ]))
}